import { render } from "./SocialMediaCreateView.vue?vue&type=template&id=5bb0e20c"
import script from "./SocialMediaCreateView.vue?vue&type=script&lang=js"
export * from "./SocialMediaCreateView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__